// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iTNH","col":"styles_col__1y4gJ"};